/**
 * SOLOMON — CostSubtitle
 *
 * Renders a small monospace cost line directly below a button.
 * Reads the static subtitle_text from the cost map; no per-lead query.
 *
 * Returns null if cost map isn't loaded yet, fetch failed, or buttonId
 * isn't in the map. Buttons still work — graceful degradation.
 */

import { useCostMap } from '../hooks/useCostMap.js';

export default function CostSubtitle({ buttonId }) {
  const { costMap } = useCostMap();
  if (!costMap) return null;

  const cfg = costMap.buttons[buttonId];
  if (!cfg) {
    console.warn(`[CostSubtitle] unknown buttonId: ${buttonId}`);
    return null;
  }

  return (
    <div className="cost-subtitle">{cfg.subtitle_text}</div>
  );
}
